import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function useResourceFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      resourceDisciplines: [],
      resourceLocations: [],
      resourcePractices: [],
      resourceBusinessUnits: [],
      resourceSkills: [],
      resourceStatusId: 'active',
      resourceTypeId: null,
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const resourceSearchParamsConfig = useMemo(
    () => ({
      resourceDisciplines: searchParamsConfig.resourceDisciplines,
      resourceLocations: searchParamsConfig.resourceLocations,
      resourcePractices: searchParamsConfig.resourcePractices,
      resourceBusinessUnits: searchParamsConfig.resourceBusinessUnits,
      resourceSkills: searchParamsConfig.resourceSkills,
      resourceStatusId: searchParamsConfig.resourceStatusId,
      resourceTypeId: searchParamsConfig.resourceTypeId,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback(
    (filters) => ({
      resourceDisciplineId: filters.resourceDisciplines?.map((v) => v.id),
      resourceLocationId: filters.resourceLocations?.map((v) => v.id),
      resourcePracticeId: filters.resourcePractices?.map((v) => v.id),
      resourceBusinessUnitId: filters.resourceBusinessUnits?.map((v) => v.id),
      resourceSkillId: filters.resourceSkills?.map((v) => v.id),
      resourceStatusId: filters.resourceStatusId ?? undefined,
      resourceTypeId: filters.resourceTypeId ?? undefined,
    }),
    [],
  );

  const mapClickThroughParams = useCallback(
    (filters) => ({
      resourceDisciplineId: filters.resourceDisciplines?.map((v) => v.id),
      resourceLocationId: filters.resourceLocations?.map((v) => v.id),
      resourcePracticeId: filters.resourcePractices?.map((v) => v.id),
      resourceBusinessUnitId: filters.resourceBusinessUnits?.map((v) => v.id),
      resourceSkillId: filters.resourceSkills?.map((v) => v.id),
      resourceStatusId: filters.resourceStatusId ?? undefined,
      resourceTypeId: filters.resourceTypeId ?? undefined,
    }),
    [],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: resourceSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams }),
    [filters, resourceSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams],
  );
}
